import { Button } from "../ui/button";
import { ArrowRight, Coffee, ShoppingBag } from "lucide-react";
import { Link } from "react-router-dom";
import ChatBox from "./ChatBox";

const UBER_EATS_URL =
  "https://www.ubereats.com/mx/store/la-dalia-cafe-lost/DsfBv9AES8yFYXru7neiXg";
const DIDI_FOOD_URL =
  "https://www.didi-food.com/es-MX/food/store/5764607535005565155/?channel=10&cityId=52090100&lat=19.413888&lng=-99.092326&ddlCode=UuUDQq&area=MX&lang=es-MX&appKey=dlp&redirectType=2";

const ModernHeroSection = () => {
  return (
    <section className="relative overflow-hidden bg-gradient-hero py-16 lg:py-24">
      <div className="container max-w-screen-xl">
        <div className="grid gap-8 lg:grid-cols-2 lg:gap-16 items-center">
          <div className="space-y-6">
            <div className="space-y-2">
              <div className="inline-flex items-center rounded-full border px-3 py-1 text-xs">
                <Coffee className="mr-2 h-3 w-3" />
                Café de especialidad
              </div>
              <h1 className="text-4xl font-bold tracking-tight sm:text-5xl lg:text-6xl">
                Bienvenid@ a{" "}
                <span className="bg-gradient-primary bg-clip-text text-transparent">
                  La Dalia Café
                </span>
              </h1>
              <p className="text-lg text-muted-foreground sm:text-xl">
                Descubre tu café perfecto y nuestros deliciosos helados mientras acumulas puntos de lealtad.
                Cada visita cuenta, cada compra te acerca a más recompensas.
              </p>
            </div>

            <div className="flex flex-col gap-4 sm:flex-row">
              <Button size="lg" className="shadow-medium" asChild>
                <Link to="/myPoints">
                  Ver mis puntos
                  <ArrowRight className="ml-2 h-4 w-4" />
                </Link>
              </Button>
            </div>

            <div className="space-y-2 pt-2">
              <p className="text-sm font-semibold">Pide a domicilio</p>
              <div className="flex flex-col gap-3 sm:flex-row">
                <Button
                  size="lg"
                  className="shadow-medium bg-[#06C167] text-black hover:bg-[#05a657]"
                  asChild
                >
                  <a href={UBER_EATS_URL} target="_blank" rel="noopener noreferrer">
                    <ShoppingBag className="mr-2 h-5 w-5" />
                    Uber Eats
                  </a>
                </Button>
                <Button
                  size="lg"
                  className="shadow-medium bg-[#FF7D41] text-white hover:bg-[#f06b2c]"
                  asChild
                >
                  <a href={DIDI_FOOD_URL} target="_blank" rel="noopener noreferrer">
                    <ShoppingBag className="mr-2 h-5 w-5" />
                    DiDi Food
                  </a>
                </Button>
              </div>
            </div>

            <div className="flex items-center space-x-8 pt-4">
              <div className="text-center">
                <div className="text-2xl font-bold text-primary">1300+</div>
                <div className="text-sm text-muted-foreground">Clientes felices</div>
              </div>
              <div className="text-center">
                <div className="text-2xl font-bold text-primary">60+</div>
                <div className="text-sm text-muted-foreground">Bebidas</div>
              </div>
              <div className="text-center">
                <div className="text-2xl font-bold text-primary">★ 4.6</div>
                <div className="text-sm text-muted-foreground">Calificación</div>
              </div>
            </div>
          </div>

          <div className="relative">
            <div className="absolute inset-0 bg-gradient-primary rounded-3xl opacity-20 blur-3xl"></div>
            <div className="relative">
              <ChatBox />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ModernHeroSection;